import Menubar from "components/Menubar/Menubar";
import React from "react";
import { customerAdminMenu } from "constants/customerAdminMenu";

const CustomerAdminMenubar = () => {
  return <Menubar color="primary" menu={customerAdminMenu} alignCenter />;
};

export default CustomerAdminMenubar;
